import {removeObjectFromCanvas} from "@frontend/utils";
import {
  ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID,
  ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ID,
  ADDITIONAL_TEXT_PREFIX_ID, BACKGROUND_THEME_IMAGE_PREFIX_ID,
  IMAGE_PREFIX_ID,
  MULTI_LINE_PREFIX_ID,
  TEXT_PREFIX_ID
} from "@frontend/constants/templates-field-prefixes";
import {drawAdditionalText} from "@/common/preview/draw-additional-text";
import {drawAdditionalMultiLineText} from "@/common/preview/draw-additional-multi-line-text";
import {
  deleteAdditionalBackgroundThemeImageField, deleteAdditionalTextField,
} from "@frontend/group/modules/additional-fields/deleting";
import {deleteDisplayBuilderBackgroundLayer} from '@frontend/group/modules/display-builder/delete-background-layer';
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";

export async function deleteLayerObject(target, canvas, options = undefined) {
  if (typeof target.deleteLayer === 'function') {
    target.canvas = canvas;
    await target.deleteLayer(options);
    canvas.remove(target);

    return;
  }

  const {updateLayoutChanges, deleteTextField, deleteImage} = ShowPageScopeCollector.get([
    'updateLayoutChanges',
    'deleteTextField',
    'deleteImage'
  ]);

  if (
    target.id.startsWith(ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ID) ||
    target.id.startsWith(ADDITIONAL_TEXT_PREFIX_ID)
  ) {
    await deleteAdditionalTextField(
      target,
      canvas.instance_id,
      window.previews,
      window.canvas_data,
      drawAdditionalText,
      canvas,
      drawAdditionalMultiLineText,
      null,
      true
    );
  } else if (
    target.id.startsWith(MULTI_LINE_PREFIX_ID) ||
    target.id.startsWith(TEXT_PREFIX_ID)
  ) {
    // For normal text fields:
    deleteTextField({
      updateLayoutChanges,
      instanceId: canvas.instance_id,
      canvas,
      selectedTextObj: target,
      disableBtnSave: true
    });
  } else if (target.id.startsWith(ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID)) {
    if (window.isDisplayBuilder) {
      deleteDisplayBuilderBackgroundLayer(target);
    } else {
      deleteAdditionalBackgroundThemeImageField(target)
    }
  } else if (target.id.startsWith(BACKGROUND_THEME_IMAGE_PREFIX_ID) || target.id.startsWith(IMAGE_PREFIX_ID)) {
    await deleteImage(target)
  } else {
    // For other object types, simply remove it from the canvas.
    removeObjectFromCanvas(canvas, target.id);
  }

  canvas.remove(target);
}
